define(["require", "exports", "./ext"], function (require, exports, ext_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ThemeModuleExtensionLoader = void 0;
    Object.defineProperty(exports, "ThemeModuleExtensionLoader", { enumerable: true, get: function () { return ext_1.ThemeModuleExtensionLoader; } });
});
